<template>
    <OrgChart />
  </template>
  
  <script>
  import OrgChart from '../components/Org-Chart/OrgChart.vue';
  
  export default {
    components: { OrgChart }
  };
  </script>